$(document).ready(function() {
  const $trigger = $('.section-announcement-bar');
  let triggerBottom = $trigger.offset().top + $trigger.outerHeight();
  let isAfterSort = false;

  function updateTriggerPosition() {
    triggerBottom = $trigger.offset().top + $trigger.outerHeight();
  }

  function updateVisibility() {
    const $target = $('.main-facets');
    if (!$target.length) return;

    const scrollTop = $(window).scrollTop();
    const windowWidth = $(window).width();

    if (windowWidth <= 749) {
      if (isAfterSort || scrollTop >= triggerBottom) {
        $target.addClass('is-fade');
      } else {
        $target.removeClass('is-fade');
      }
    } else {
      $target.removeClass('is-fade');
      isAfterSort = false;
    }
  }

  function scrollToTriggerBottom() {
    updateTriggerPosition();
    $('html, body').animate({ scrollTop: triggerBottom }, 400);
  }

  $(window).on('resize', function() {
    updateTriggerPosition();
    updateVisibility();
  });

  $(window).on('load scroll', updateVisibility);

  $(document).on('click', '.js-btn-option', function() {
    if ($(window).width() <= 749) {
      isAfterSort = true;
      scrollToTriggerBottom();
    }
  });

  const observer = new MutationObserver(function(mutations) {
    const hasAddedNodes = mutations.some(function(mutation) {
      return mutation.addedNodes.length > 0;
    });

    if (!hasAddedNodes) return;

    if (isAfterSort) {
      setTimeout(function() {
        const $target = $('.main-facets');
        if ($target.length) $target.addClass('is-fade');
      }, 100);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  updateVisibility();
});